// VALM CUSTOM: Keep surrounding whitespace outside text links so only words are underlined.
(() => {
  const tidyLinks = root => {
    root.querySelectorAll('.article__content a[href]').forEach(link => {
      if (link.matches('.btn, .button, .blog-image-overlay') ||
          link.querySelector('img, svg, button, input, video, audio, iframe, br') ||
          !link.textContent.trim()) return;

      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      let leading = '';
      for (const node of nodes) {
        const whitespace = node.data.match(/^\s+/)?.[0] || '';
        leading += whitespace;
        node.data = node.data.slice(whitespace.length);
        if (node.data) break;
      }

      let trailing = '';
      for (const node of [...nodes].reverse()) {
        const whitespace = node.data.match(/\s+$/)?.[0] || '';
        trailing = whitespace + trailing;
        node.data = node.data.slice(0, node.data.length - whitespace.length);
        if (node.data) break;
      }

      if (leading) link.before(leading);
      if (trailing) link.after(trailing);
    });
  };

  tidyLinks(document);
  document.addEventListener('shopify:section:load', event => tidyLinks(event.target));
})();
